import React, { useContext } from 'react';
import { Form, Link, useNavigate } from 'react-router-dom';
import img from "../../assets/images/login.jpg";
import { AuthContext } from '../../Context/AuthProvider/AuthProvider';


const Signup = () => {
    const {userSignUp,profileUpdate} = useContext(AuthContext)
    const navigate = useNavigate();
    const handleSignup=(e)=>{
        e.preventDefault();
        const form = e.target;
        const email = form.email.value;
        const password = form.password.value;
        const name =form.name.value;
        const photo = form.photo.value;

        userSignUp(email,password)
        .then(result=>{
            const user = result.user;
            navigate('/login');

            profileUpdate(name,photo)
            .then((res)=>{})
            .catch((err)=>{console.log(err);})
            console.log(user);
            form.reset();
        })
        .catch(error=>console.error(error))

    }
    return (
        <div className="hero my-20 min-h-screen bg-base-200">
        
        <div className="hero-content gap-10 grid md:grid-cols-2 flex-col lg:flex-row">
          <div className="text-center lg:text-left">
          <img className="w-3/4 " src={img} alt="" />
          </div>
          <Form onSubmit={handleSignup} className="card  flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
            <div className="card-body">
              <h1 className="text-3xl font-bold">Sign Up now!</h1>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Name</span>
                </label>
                <input
                  type="text"
                  placeholder="Your Name"
                  name='name'
                  className="input input-bordered"
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Photo URL</span>
                </label>
                <input
                  type="text"
                  placeholder="Your Name"
                  name='photo'
                  className="input input-bordered"
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Email</span>
                </label>
                <input
                  type="email"
                  name='email'
                  placeholder="email"
                  className="input input-bordered"
                  required
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Password</span>
                </label>
                <input
                  type="password"
                  name='password'
                  placeholder="password"
                  className="input input-bordered"
                  required
                />
                <label className="label">
                  <a href="#" className="label-text-alt link link-hover">
                    Forgot password?
                  </a>
                </label>
              </div>
              <div className="form-control mt-6">
                <button className="btn btn-primary">Sign up</button>
              </div>
              <p>Already Have an Account?<Link to='/login'><span className="text-orange-700 px-5 font-bold">Login</span></Link> </p>
            </div>
          </Form>
        </div>
      </div>
    );
};

export default Signup;